module.exports = __webpack_public_path__ + "8c3e0fae59dc242e01bdd94aedc5848f.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/210.png
// module id = 1776
// module chunks = 2